import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import SortUpIcon from '@flipster/ui/assets/svgs/sort-up.svg';

import { OrderByType } from '../../../types';

interface Props {
  isSorted: boolean;
  sortOrder: OrderByType;
}

export const Sort = ({ isSorted, sortOrder }: Props) => {
  return (
    <div className={vstack({ gap: 1, width: 16, height: 16, ml: 2, lineHeight: 0, color: 'content.default.level-1' })}>
      <span className={css(isSorted && sortOrder === 'asc' && { color: 'inverse.white' })}>
        <SortUpIcon width={8} height={8} />
      </span>
      <span
        className={css({ transform: 'rotate(180deg)' }, isSorted && sortOrder === 'desc' && { color: 'inverse.white' })}
      >
        <SortUpIcon width={8} height={8} />
      </span>
    </div>
  );
};
